import * as React from 'react';

import { Modal } from 'security-app/components/common';

import EventProcedureForm from '../plugin/EventProcedureForm';

type Props = {
  onClose: () => void;
  eventProcedureID?: string | undefined;
  isCreate?: boolean;
};

function EventProcedureModal({ onClose, eventProcedureID = '', isCreate = false }: Props) {
  return (
    <Modal
      show
      onClose={onClose}
      maxWidth="700px"
      title={`${eventProcedureID ? 'Edit' : 'Create'} Event Procedure`}
      showClose>
      <EventProcedureForm onClose={onClose} eventProcedureID={eventProcedureID} isCreate={isCreate} isModalView />
    </Modal>
  );
}

export default EventProcedureModal;
